import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { get } from 'lodash'
import { LogCard } from 'components/sections/activity'
import {
  ElevatedButton,
  FixedRightBottom,
  Logs,
  Placeholders
} from 'components/layout'
import { LogDetail } from 'components/sections/dashboard'
import { ACTIVITY_SECTIONS, ACTIVITY_STATES, CONFIGURATION_KEYS } from 'constants/enums'
import { SignOff } from 'containers/forms/dashboard'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import modals from 'constants/layout/modals'
import { modal } from 'helpers/decorators'
import { apiConfiguration } from '../../../helpers/decorators/api'
import { connect } from 'react-redux'
import AcceptActivity from '../../forms/dashboard/AcceptActivity/AcceptActivity'

const logSchema = journey => ({
  description: get(journey, 'observations'),
  date: get(journey, 'ajEvent.endDate'),
  category: get(journey, 'ajEvent.activityCategory.translatedName'),
  fileUrls: get(journey, 'fileUrls')
})

@injectIntl
@apiConfiguration()
@connect(({ api }) => ({
  configuration: api.configuration
}))
@modal.trigger()
class AJLogsAssessor extends Component {
  static propTypes = {
    onOpen: PropTypes.func,
    journey: PropTypes.object,
    intl: PropTypes.object,
    configuration: PropTypes.object.isRequired
  }

  handleOpenSignOff = () => this.props.onOpen(modals.SIGN_OFF)
  handleOpenLogDetail = () => this.props.onOpen(modals.LOG_DETAIL)
  handleOpenAcceptActivity = () => this.props.onOpen(modals.ACCEPT_ACTIVITY)

  render() {
    const { journey, intl } = this.props

    const ajId =  get(journey, 'ajEvent.id')

    const setup = get(journey, 'ajEvent.isAcceptedByAssessor') === false
      && get(journey, 'state.value') === ACTIVITY_STATES.in_progress.id

    const signoffable =
      get(journey, 'state.value') === ACTIVITY_STATES.assessment.id &&
      get(journey, 'isAssessmentPositive') === false

    const AJ_SECTION = ACTIVITY_SECTIONS.adventurous_journey.id

    const colorClass = getActivityClassName(AJ_SECTION)

    const noReportText = intl.formatMessage({
      id: 'label.waiting_for_participant_report',
      defaultMessage: 'Waiting for participant to submit their report.'
    })

    const isAssessorReportAdditionalInfoEnabled = get(this.props,`configuration.values.${CONFIGURATION_KEYS.isAssessorReportAdditionalInfoEnabled.id}.booleanValue`)

    return (
      <Logs.Wrap>
        {get(journey, 'observations') ? (
          <Logs.Item>
            <LogCard
              log={logSchema(journey)}
              activitySection={AJ_SECTION}
              onOpenDetail={this.handleOpenLogDetail}
              variableHeight
            />
          </Logs.Item>
        ) : (
          <Placeholders.LogsPlaceholder customMessage={noReportText} />
        )}
        {signoffable && (
          <FixedRightBottom>
            <ElevatedButton
              onClick={this.handleOpenSignOff}
              colorClass={colorClass}
              intlKey="button.sign_off_dashed"
              high
              large
              oval
              uppercase
            >
              Sign off
            </ElevatedButton>
          </FixedRightBottom>
        )}
        {setup &&
        <FixedRightBottom>
          <ElevatedButton
            onClick={this.handleOpenAcceptActivity}
            colorClass={colorClass}
            intlKey="label.accept_becoming_assessor"
            high
            large
            oval
            uppercase
          >
            Become the assessor
          </ElevatedButton>
        </FixedRightBottom>}
        {signoffable && (
          <SignOff
            id={get(journey, 'id')}
            activitySection={AJ_SECTION}
            colorClass={colorClass}
            modalId={modals.SIGN_OFF}
            actionId={get(
              journey,
              'ajParticipantEventAssessmentRequestActionId'
            )}
            isAssessorReportAdditionalInfoEnabled={isAssessorReportAdditionalInfoEnabled}
            isAjRequest
          />
        )}
        <LogDetail
          modalId={modals.LOG_DETAIL}
          colorClass={colorClass}
          editable={false}
          isObservation
          log={{
            description: get(journey, 'observations'),
            fileUrls: get(journey, 'fileUrls'),
            date: get(journey, 'ajEvent.endDate')
          }}
        />
        {setup &&
        <AcceptActivity
          colorClass={colorClass}
          id={ajId}
          modalId={modals.ACCEPT_ACTIVITY}
          isAjRequest
        />}
      </Logs.Wrap>
    )
  }
}

export default AJLogsAssessor
